function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-198.434 -232.762)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(296.73 327.014)",
  opacity: 0.2
}, /*#__PURE__*/React.createElement("path", {
  d: "M277.751,301.45H238.74V249.19h27.391l11.62,10.644Z",
  transform: "translate(-238.74 -247.435)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M279.391,300.176H240.38V247.93h27.391l11.62,10.644Z",
  transform: "translate(-238.095 -247.93)",
  fill: "#fff",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M260.846,247.93l-2.856,12.5,14.476-1.853Z",
  transform: "translate(-231.17 -247.93)",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M260.04,247.93v10.644h11.62Z",
  transform: "translate(-230.364 -247.93)",
  fill: "#fff",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("line", {
  x2: 22.236,
  transform: "translate(9.739 18.321)",
  fill: "#fff",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("line", {
  x2: 22.236,
  transform: "translate(9.739 23.769)",
  fill: "#fff",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("line", {
  x2: 22.236,
  transform: "translate(9.739 29.216)",
  fill: "#fff",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("line", {
  x2: 22.236,
  transform: "translate(9.739 34.678)",
  fill: "#fff",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("line", {
  x2: 22.236,
  transform: "translate(9.739 40.125)",
  fill: "#fff",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(346.3 232.762)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 69.3,
  cy: 13.319,
  rx: 69.3,
  ry: 13.319,
  transform: "translate(12.236 250.434)",
  fill: "#015b80"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 69.3,
  cy: 13.319,
  rx: 69.3,
  ry: 13.319,
  transform: "translate(12.236 250.434)",
  fill: "#fff",
  opacity: 0.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M284.248,240.723a.99.99,0,0,1-.307.209,1.184,1.184,0,0,1-1.574-.571l-2.786-5.866a1.2,1.2,0,0,1,2.16-1.017l2.786,5.866A1.184,1.184,0,0,1,284.248,240.723Z",
  transform: "translate(-255.279 -159.594)",
  fill: "#fff",
  stroke: "#263238",
  strokeMiterlimit: 10,
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M284.79,251.852a16.245,16.245,0,0,1,8.136,3.539c3.9,3.19,12.4,7.44,23.392,9.92s13.807,2.786,13.807,2.786L327.34,252.87s-15.59.348-22.292-.711-14.531-7.078-18.112-10.268S284.79,251.852,284.79,251.852Z",
  transform: "translate(-253.313 -156.249)",
  fill: "#015b80",
  stroke: "#263238",
  strokeMiterlimit: 10,
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M291.033,254.4a2.1,2.1,0,0,1-.446.307,1.8,1.8,0,0,1-2.382-.85l-6.966-14.7a1.789,1.789,0,0,1,3.232-1.533l6.966,14.7A1.811,1.811,0,0,1,291.033,254.4Z",
  transform: "translate(-254.666 -158.131)",
  fill: "#fff",
  stroke: "#263238",
  strokeMiterlimit: 10,
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M293.385,240.584a18.6,18.6,0,1,1,.947-26.29,18.6,18.6,0,0,1-.947,26.29Zm-22.9-24.632a15.033,15.033,0,1,0,21.233.766A15.033,15.033,0,0,0,270.48,215.951Z",
  transform: "translate(-262.117 -169.236)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M286.755,238.833s1.937-1.031,2.786.557,2.954,4.89,2.55,6.088-2.661,1.393-3.762.153a23.126,23.126,0,0,1-2.619-5.127Z",
  transform: "translate(-252.84 -157.384)",
  fill: "#fff",
  stroke: "#263238",
  strokeMiterlimit: 10,
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M281.451,241.109l7.44-2.368a2.145,2.145,0,0,1,.975,1.56c.153,1.115,3.288,7.314,2.94,8.875s-7.147,4.417-7.83,3.567-4.7-10.533-4.7-10.533S280.169,241.471,281.451,241.109Z",
  transform: "translate(-254.976 -157.291)",
  fill: "#fff",
  stroke: "#263238",
  strokeMiterlimit: 10,
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("line", {
  x1: 6.715,
  y2: 2.09,
  transform: "translate(28.328 84.124)",
  fill: "none",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("line", {
  x1: 6.116,
  y2: 2.369,
  transform: "translate(29.902 87.022)",
  fill: "none",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("line", {
  x1: 5.796,
  y2: 3.274,
  transform: "translate(31.351 89.71)",
  fill: "none",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M317.5,222.57s-6.033,11.327-6.729,22.668,9.558,12.748,10.979,13.807,6.729,45.7,6.729,45.7-37.2,47.83-37.2,53.138S286,415.31,286,415.31l7.788.362s11.717-32.992,14.5-40.766,3.887-19.84,3.887-19.84l34.371-32.24s3.887,31.529,7.44,38.258,27.976,55.27,27.976,55.27a37.62,37.62,0,0,0,6.381,1.059,11.062,11.062,0,0,0,4.249-1.059l-20.9-59.909s1.059-54.559-3.539-63.42-16.3-21.609-16.3-21.609-9.92-41.087-11.341-47.468-9.558-11.689-13.459-11.689S317.5,222.57,317.5,222.57Z",
  transform: "translate(-252.726 -167.704)",
  fill: "#015b80",
  stroke: "#263238",
  strokeMiterlimit: 10,
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M304,217.154l4.96,7.788s-2.786,12.051-.348,9.223,6.367-13.11,8.5-15.242a11.968,11.968,0,0,0,2.786-4.96L309.35,208Z",
  transform: "translate(-245.648 -169.379)",
  fill: "#fff",
  stroke: "#263238",
  strokeMiterlimit: 10,
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M288.234,196.289s-.627,6.506,1.491,9.753,2.786,4.249,2.132,6.367-3.9,2.132-3.191,3.9,4.612,2.48,4.612,2.48,4.249,9.92,8.137,9.92,13.849-9.753,15.256-13.305-13.124-12.915-15.6-15.033S291.063,192.388,288.234,196.289Z",
  transform: "translate(-251.881 -174.499)",
  fill: "#fff",
  stroke: "#263238",
  strokeMiterlimit: 10,
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M295.053,205.3c.39,1.184.265,2.3-.293,2.48s-1.393-.627-1.714-1.811-.279-2.3.279-2.494S294.649,204.105,295.053,205.3Z",
  transform: "translate(-250.034 -171.169)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M293.65,214.116s3.427,0,4.57-4.946",
  transform: "matrix(-0.766, -0.643, 0.643, -0.766, 137.845, 396.075)",
  fill: "none",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M292.456,185.546h-7.328c-4.709,0-5.225,9.4,4.709,19.868s29.8,23,41.309,23,21.442,3.135,25.622,14.643,10.979,21.957,31.376,17.778,25.622-31.891,10.979-55.423-33.995-19.352-43.929-14.643-26.667,6.27-29.8,0S314.845,180.28,307,180.28,292.456,185.546,292.456,185.546Z",
  transform: "translate(-254.348 -180.28)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M392.6,399.448l-20.9-59.909s1.059-54.559-3.539-63.42c-3.957-7.593-13.1-18.028-15.618-20.9l-27.182,8.053c1.616,11.982,3.121,24.591,3.121,24.591s-37.2,47.83-37.2,53.138S286,398.417,286,398.417l7.788.362s11.717-32.992,14.5-40.766,3.887-19.84,3.887-19.84l34.371-32.239s3.887,31.529,7.44,38.258,27.976,55.27,27.976,55.27a37.62,37.62,0,0,0,6.381,1.059,11.061,11.061,0,0,0,4.249-1.073Z",
  transform: "translate(-252.726 -150.811)",
  stroke: "#263238",
  strokeMiterlimit: 10,
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M321.582,219.963a6.618,6.618,0,0,0-7.8,4.249c-2.118,5.67,6.729,10.63,13.459,18.112s26.221,22.668,26.221,22.668L364.8,301.133l5.308-1.073s-7.133-41.128-7.133-42.187-29.746-30.47-30.818-31.529-5.308-5.67-5.308-5.67",
  transform: "translate(-241.927 -164.749)",
  fill: "#015b80",
  stroke: "#263238",
  strokeMiterlimit: 10,
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M350.912,278.439l-2.132,9.209,3.539,6.729s2.786,1.059,3.553-.362l.7-1.393s3.553-.362,3.9-3.553-4.249-11.689-4.249-11.689Z",
  transform: "translate(-228.039 -142.097)",
  fill: "#fff",
  stroke: "#263238",
  strokeMiterlimit: 10,
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M291.117,358S273.757,370.762,273,372.88s23.379-3.539,25.51-3.9.348-10.617.348-10.617Z",
  transform: "translate(-257.843 -110.394)",
  fill: "#015b80",
  stroke: "#263238",
  strokeMiterlimit: 10,
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M274.784,368.606a7.705,7.705,0,0,0-1.769,2.006c-.711,2.132,23.378-3.539,25.51-3.9.724-.111.989-1.393,1.031-3.051Z",
  transform: "translate(-257.838 -108.168)",
  fill: "#fff",
  stroke: "#263238",
  strokeMiterlimit: 10,
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M358.52,358.775s-14.518,2.48-12.748,4.6a15.074,15.074,0,0,0,9.92,4.18c3.539,0,4.96,1.059,8.151,2.786s5.308,1.769,6.367-1.073-1.059-10.617-1.059-10.617S360.652,360.531,358.52,358.775Z",
  transform: "translate(-229.28 -110.138)",
  fill: "#015b80",
  stroke: "#263238",
  strokeMiterlimit: 10,
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M363.843,369.537c3.177,1.769,5.308,1.769,6.367-1.073a3.957,3.957,0,0,0,.223-1c-5.28,2.661-10.143-3.664-14.573-3.664-2.786,0-6.674-1.546-9.251-2.786-.836.474-1.226.947-.836,1.393a15.074,15.074,0,0,0,9.92,4.18C359.232,366.694,360.653,367.753,363.843,369.537Z",
  transform: "translate(-229.281 -109.21)",
  fill: "#fff",
  stroke: "#263238",
  strokeMiterlimit: 10,
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M296.59,196.44c2.786,5.573,6.813,12.219,11.466,14.936",
  transform: "translate(-248.562 -173.925)",
  fill: "none",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 0.75
}), /*#__PURE__*/React.createElement("path", {
  d: "M293.74,189.75s.627,1.825,1.769,4.514",
  transform: "translate(-249.682 -176.556)",
  fill: "none",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 0.75
}), /*#__PURE__*/React.createElement("path", {
  d: "M366.31,204.68a17.278,17.278,0,0,1,3.26,3.455",
  transform: "translate(-221.145 -170.685)",
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  strokeWidth: 0.75
}), /*#__PURE__*/React.createElement("path", {
  d: "M287.23,188.52s4.9,16.719,21.316,24.493,23.03,6.13,43.845-2.926c15.939-6.966,31.6-6.548,41.254-1.491",
  transform: "translate(-252.242 -177.04)",
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  strokeWidth: 0.75
}), /*#__PURE__*/React.createElement("path", {
  d: "M345.433,229.538c-.265-5.392,5.252-4.612,5.893-4.4",
  transform: "translate(-229.359 -162.705)",
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  strokeWidth: 0.75
}), /*#__PURE__*/React.createElement("path", {
  d: "M325.57,207.933s9.558-1.714,28.171-1.477,30.136,19.366,26.472,30.874c-3.372,10.561-20.759,10.616-25.5,4.18",
  transform: "translate(-237.166 -169.995)",
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  strokeWidth: 0.75
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(198.434 327.014)",
  opacity: 0.2
}, /*#__PURE__*/React.createElement("path", {
  d: "M277.751,301.45H238.74V249.19h27.391l11.62,10.644Z",
  transform: "translate(-238.74 -247.435)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M279.391,300.176H240.38V247.93h27.391l11.62,10.644Z",
  transform: "translate(-238.095 -247.93)",
  fill: "#fff",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M260.846,247.93l-2.856,12.5,14.476-1.853Z",
  transform: "translate(-231.17 -247.93)",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M260.04,247.93v10.644h11.62Z",
  transform: "translate(-230.364 -247.93)",
  fill: "#fff",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("line", {
  x2: 22.236,
  transform: "translate(9.739 18.321)",
  fill: "#fff",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("line", {
  x2: 22.236,
  transform: "translate(9.739 23.769)",
  fill: "#fff",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("line", {
  x2: 22.236,
  transform: "translate(9.739 29.216)",
  fill: "#fff",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("line", {
  x2: 22.236,
  transform: "translate(9.739 34.678)",
  fill: "#fff",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("line", {
  x2: 22.236,
  transform: "translate(9.739 40.125)",
  fill: "#fff",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-1476.27 307.003)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(1724 20)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 41,
  height: 54,
  rx: 4,
  opacity: 0.05
})), /*#__PURE__*/React.createElement("path", {
  d: "M7.884,102.068l4.087-4.087a.606.606,0,0,0,0-.857l-.95-.95a.606.606,0,0,0-.857,0l-4.087,4.088L1.991,96.175a.606.606,0,0,0-.857,0l-.949.949a.606.606,0,0,0,0,.857l4.087,4.087L.185,106.156a.606.606,0,0,0,0,.857l.95.95a.606.606,0,0,0,.857,0l4.087-4.088,4.087,4.087a.606.606,0,0,0,.857,0l.95-.95a.606.606,0,0,0,0-.857Z",
  transform: "translate(1737.993 -54.998)",
  opacity: 0.7
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(1729 32)",
  fill: "none",
  stroke: "#484848",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("rect", {
  width: 31,
  height: 31,
  rx: 15.5,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 30,
  height: 30,
  rx: 15,
  fill: "none"
}))));

function SvgSearchIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 300.986,
    height: 277.073,
    viewBox: "0 0 300.986 277.073",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "search-icon.5ef4b03.svg";
export { ForwardRef as ReactComponent };